import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app';

interface BreadcrumbState {
  isLoading: boolean;
  title: string;
}

const initialState: BreadcrumbState = {
  isLoading: false,
  title: '',
};

const breadcrumbSlice = createSlice({
  name: 'breadcrumb',
  initialState,
  reducers: {
    loadingBreadcrumb(state) {
      state.isLoading = true;
      state.title = '';
    },
    setBreadcrumb(
      state,
      action: PayloadAction<{
        title: string;
      }>
    ) {
      state.isLoading = false;
      state.title = action.payload.title;
    },
  },
  extraReducers: {},
});

const { actions, reducer: breadcrumbReducer } = breadcrumbSlice;

export const { loadingBreadcrumb, setBreadcrumb } = actions;

export default breadcrumbReducer;

export const selectBreadcrumb = (state: RootState): BreadcrumbState =>
  state.breadcrumb as BreadcrumbState;
